import React, { Component } from 'react';
import { Button } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const yearFormat = 'YYYY';
let year = moment().format(yearFormat);

class Filter extends Component {
    render() {
        const { ...rest } = this.props;
        const filters = [{
            name: '入职时间',
            key: 'begin',
            type: 'datePicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '至',
            key: 'end',
            type: 'datePicker',
            typeProperty: {
                allowClear: false,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

class CrcFirstlyWorkTime extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams: {
            begin: `${year}-01-01`,
            end: `${year}-12-31`,
        },
        curParams: {
            begin: `${year}-01-01`,
            end: `${year}-12-31`,
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryCRCEarliestHour,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...curParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const url = API_URL.dashboard.exportCRCEarliestHour;
        ExportUtil.export({ ...sortParams, ...curParams }, null, url);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: '大区',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 90,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 90,
        },{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }, {
            title: '职位级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 110,
        }, {
            title: '部门',
            dataIndex: 'enterpriseDepartmentName',
            key: 'enterpriseDepartmentName',
            width: 130,
        }, {
            title: '入职时间',
            dataIndex: 'joinTimeShow',
            key: 'joinTimeShow',
            width: 90,
        }, {
            title: '在职状态',
            dataIndex: 'workStatusShow',
            key: 'workStatusShow',
            width: 80,
        }, {
            title: '直线主管',
            dataIndex: 'leaderUser',
            key: 'leaderUser',
            width: 100,
        }, {
            title: '首次填写项目工时时间',
            dataIndex: 'writeDateShow',
            key: 'writeDateShow',
            width: 100,
        }, {
            title: '首次产生项目确认FTE月份',
            dataIndex: 'confirmMonth',
            key: 'confirmMonth',
            width: 100,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <TableC
                    data={data}
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    className="crcFirstlyWorkTime"
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default CrcFirstlyWorkTime;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/crcFirstlyWorkTime.js